export default "__VITE_ASSET__C0HlKih3__"